import { useEffect } from "react"
import { useLocation } from "@/lib/router"

/**
 * Hook that scrolls the window to the top when the pathname changes.
 */
export const useScrollToTop = () => {
	const location = useLocation()
	useEffect(() => {
		window.scrollTo(0, 0)
	}, [location.pathname])
}
